// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Logo_logoWrapper__ssL6n","logo":"Logo_logo__z4YBr"};